import { useEffect, useMemo } from 'react';
import { SdkConfig, sdk } from '@/sdk';
import { Locale } from '@/i18n';
import { ProviderContext } from './context';
import { Theme } from '@/types';

export type ProviderProps = {
  sdk?: SdkConfig;
  theme?: string | Theme;
  locale?: Locale;
};

export function Provider({
  sdk: sdkConfig = {},
  theme = {},
  locale,
  children,
}: React.PropsWithChildren<ProviderProps>) {
  const { authToken } = sdkConfig;

  const sdkInstance = useMemo(() => {
    console.log('Initializing sdk...', sdkConfig);
    return sdk.init({ ...sdkConfig, authToken });
  }, [sdkConfig, authToken]);

  useEffect(() => {
    const themeObj =
      typeof theme === 'string' ? { id: theme, darkmode: false } : theme;

    if (typeof window !== 'undefined') {
      if (themeObj.id) document.body.setAttribute('data-mm-theme', themeObj.id);

      if (themeObj.darkmode) {
        document.body.classList.add('mm-dark');
      } else if (document.body.classList.contains('mm-dark')) {
        document.body.classList.remove('mm-dark');
      }

      document.body.setAttribute('data-brand', themeObj.variant || '');
    }
  }, [theme]);

  return (
    <ProviderContext.Provider value={{ sdk: sdkInstance, i18n: locale }}>
      {children}
    </ProviderContext.Provider>
  );
}
